import * as css from 'css/exports.module.scss';

import './OwnersSummary.scss';

import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { FeatureFlag } from '@sonar-software/sonar-core';
import { InitiativeSubSection } from '../general/InitiativeSubSection';
import React from 'react';
import { SonarUser } from '@ui/SonarUser';
import { Space } from 'antd';
import { TeamOutlined } from '@ant-design/icons';
import { UserAvatarGroup } from '@ui/avatar';
import { When } from 'react-if';

import { useFeatureFlag, useInitiativeReference } from '@hooks';

export interface InitiativeOwnersSummaryProps {
	initiativeId: number;
}

export const InitiativeOwnersSummary: React.FC<InitiativeOwnersSummaryProps> = ({ initiativeId }) => {
	const isEnabled = useFeatureFlag(FeatureFlag.DataDictionary);

	const { ownerIds } = useInitiativeReference(initiativeId);

	if (!isEnabled) {
		return null;
	}

	return (
		<InitiativeSubSection
			bold
			count={ ownerIds.length ?? 0 }
			icon={ <TeamOutlined /> }
			id='initiative-owners-summary'
			title={ COPY_SPECIFIC.OWNERS_IMPACTED }>
			<When condition={ ownerIds.length }>
				<Space
					direction='vertical'
					size={ Number(css.size8) }>
					{ ownerIds.slice(0, 3).map((id) =>
						<SonarUser
							key={ id }
							showTooltip
							userId={ id } />) }
					<UserAvatarGroup
						maxCount={ 5 }
						userIds={ ownerIds.slice(3) } />
				</Space>
			</When>
		</InitiativeSubSection>
	);
};
